import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//actions
import { postUpdated, updateFilterSelected } from '../actions';

class SearchField extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.keypress = this.keypress.bind(this);
    this.filterNameField = this.filterNameField.bind(this);
    this.state = {
      value: '',
      suggestions: []
    };
  }

  keypress = e => {
    let charInState = this.inputRef.current.value;
    this.filterNameField(charInState);
  };

  filterNameField = value => {
    //update filters in redux
    //console.log(this.props.data);
    this.props.updateFilterSelected('name', value);
    this.props.postUpdated('asc', value, this.props.data, 'title');
  };

  componentDidUpdate(prevProps, prevState) {
   if (this.props.filters.clear_filter.active) {
    this.clearField();
   }
  }

  clearField() {
    this.inputRef.current.value = '';
  }

  render() {
    return (
      <div className="form-group form-group-columned form-group-lined col-sm-12 col-md-7 col-lg-8">
        <input placeholder="Search" className="form-control" ref={this.inputRef} type="text" onKeyUp={this.keypress} />
      </div>
    );
  }
}

SearchField.propTypes = {
  data: PropTypes.array
};

const mapDispatchToProps = dispatch => {
  return {
    postUpdated: (sortBy, value, filteredData, filterSelected) =>
      dispatch(postUpdated(sortBy, value, filteredData, filterSelected)),
    updateFilterSelected: (filtername, value) => dispatch(updateFilterSelected(filtername, value))
  };
};

const mapStateToProps = state => {
  return {
    type: state.postData.type,
    filteredData: state.postData.filteredData,
    data: state.postData.data,
    filters: state.filters
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchField);
